module.exports = __webpack_public_path__ + "img/efficiency1.a892291a.png";